import type { Theme } from '@mui/material/styles';
import { tbColors } from 'styles/colors/tbColors';

const getMuiMenuItem = () => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      fontSize: 14,
      paddingTop: 4,
      paddingBottom: 4,
      color: theme.palette.semantic.text.primary,
      [theme.breakpoints.up('sm')]: {
        minHeight: 48,
      },
      '&:hover, &:focus-within': {
        backgroundColor: theme.palette.semantic.interactive.surface.hover,
      },
      '&.Mui-selected': {
        backgroundColor: tbColors.all.snow[100],
        '& span': {
          fontWeight: 'initial',
        },
      },
      '&.Mui-selected:hover': {
        backgroundColor: theme.palette.semantic.interactive.selected.hover,
        color: `${theme.palette.semantic.text.primary}`,
      },
      "&.Mui-selected.Mui-focusVisible[data-multiple='false']": {
        backgroundColor: theme.palette.semantic.interactive.surface.active,
      },
      '& .MuiListItemIcon-root': {
        minWidth: 30,
      },
      '& svg': {
        fontSize: '1.42rem',
      },
      '&.MuiButtonBase-root.Mui-disabled': {
        cursor: 'not-allowed',
        opacity: 0.5,
        pointerEvents: 'inherit',
        '& input': {
          cursor: 'not-allowed',
          pointerEvents: 'none',
        },
        '&:hover': {
          backgroundColor: 'inherit',
        },
        '&:active': {
          pointerEvents: 'none',
        },
        '& > *': {
          pointerEvents: 'none',
        },
      },
      '&[data-testid^="breadcrumb-dropdown-item"]': {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '18px',
        paddingTop: '4px',
        paddingBottom: '4px',
        paddingLeft: '12px',
        paddingRight: '12px',
        '&:hover': {
          backgroundColor: '#F5F5F5',
        },
        '& > .MuiBox-root': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '200px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          minWidth: 0,
          '& span': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            minWidth: 0,
          },
        },
      },
    }),
  },
});

export default getMuiMenuItem;
